import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/system';


// Style wrapper for article-like formatting
const ContentWrapper = styled('div')(({ theme }) => ({
    '& h1, h2, h3': {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(1.5),
      fontWeight: 600,
    },
    '& p': {
      marginBottom: theme.spacing(2),
      lineHeight: 1.7,
      fontSize: '1.1rem',
    },
    '& ul, ol': {
      marginLeft: theme.spacing(3),
      marginBottom: theme.spacing(2),
    },
    '& img': {
      maxWidth: '100%',
      margin: theme.spacing(2, 0),
      borderRadius: '8px',
    },
    '& blockquote': {
      fontStyle: 'italic',
      borderLeft: `4px solid ${theme.palette.primary.main}`,
      paddingLeft: theme.spacing(2),
      margin: theme.spacing(2, 0),
      color: theme.palette.text.secondary,
    },
  }));
function ArticleViewer(props) {
  let htmlContent = '';
  try {
    const parsed = JSON.parse(props.contentJson);
    htmlContent = parsed?.html || '';
  } catch (e) {
    htmlContent = '<p>Invalid content format</p>';
  }

  
  return (
    
      <CardContent>
        <ContentWrapper dangerouslySetInnerHTML={{ __html: htmlContent }} />
       
      </CardContent>
   
  );
}

export default ArticleViewer;
